import { render, staticRenderFns } from "./Akfimsfarmer.vue?vue&type=template&id=b7ce0f86&scoped=true&"
import script from "./Akfimsfarmer.vue?vue&type=script&lang=js&"
export * from "./Akfimsfarmer.vue?vue&type=script&lang=js&"
import style0 from "./Akfimsfarmer.vue?vue&type=style&index=0&id=b7ce0f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ce0f86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VCombobox,VContainer,VForm,VImg,VRow,VTab,VTabItem,VTabs,VTextField})
